module.exports = __webpack_public_path__ + "sflyssofe.516da37493.svg";